import { useEffect, useState } from "react";
import Lenis from "lenis";

import { SiteConfigProvider } from "@/context/SiteConfig";
import { CustomInject } from "@/components/CustomInject";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Loader } from "@/components/Loader";
import { Particles } from "@/components/Particles";
import { Header } from "@/components/Header";
import { BackToTop } from "@/components/BackToTop";
import { Hero } from "@/sections/Hero";
import { EditorialMarquee } from "@/sections/Marquee";
import { PlatformOfWeek } from "@/sections/PlatformOfWeek";
import { Stats } from "@/sections/Stats";
import { SignalGenerator } from "@/sections/SignalGenerator";
import { OpportunityGenerator } from "@/sections/OpportunityGenerator";
import { LiveRTP } from "@/sections/LiveRTP";
import { PopularGames } from "@/sections/PopularGames";
import { Ranking } from "@/sections/Ranking";
import { RtpChart } from "@/sections/RtpChart";
import { NossaEmpresa } from "@/sections/NossaEmpresa";
import { Avisos } from "@/sections/Avisos";
import { Footer } from "@/sections/Footer";

function SiteBody() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1900);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative bg-[#120D0D] text-white min-h-screen overflow-x-hidden" data-testid="app-root">
      <Loader show={loading} />
      <div className="grain" aria-hidden="true" />
      <Particles count={28} />
      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <PlatformOfWeek />
          <Stats />
          <SignalGenerator />
          <OpportunityGenerator />
          <LiveRTP />
          <PopularGames />
          <Ranking />
          <RtpChart />
          <NossaEmpresa />
          <Avisos />
        </main>
        <Footer />
      </div>
      <BackToTop />
      <WhatsAppButton />
    </div>
  );
}

export default function PublicSite() {
  return (
    <SiteConfigProvider>
      <CustomInject />
      <SiteBody />
    </SiteConfigProvider>
  );
}
